export const CORPORATESECTORLIST_SEARCH = 'CORPORATESECTORLIST_SEARCH';
export const CORPORATESECTORLIST_PAGE = 'CORPORATESECTORLIST_PAGE';
